import { render, staticRenderFns } from "./EventDayTeamCard.vue?vue&type=template&id=c0aea3a8&scoped=true&"
import script from "./EventDayTeamCard.vue?vue&type=script&lang=js&"
export * from "./EventDayTeamCard.vue?vue&type=script&lang=js&"
import style0 from "./EventDayTeamCard.vue?vue&type=style&index=0&id=c0aea3a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0aea3a8",
  null
  
)

export default component.exports